import { motion } from "framer-motion";
import { ArrowUpRight, Car } from "lucide-react";
import { SERVICES } from "@/data/site";

export default function Services() {
  return (
    <section id="services" data-testid="services-section" className="rs-section bg-[#F8FAFC]">
      <div className="rs-container">
        <div className="max-w-3xl">
          <p className="rs-overline mb-4">Our Services</p>
          <h2 className="font-display font-semibold text-3xl sm:text-4xl lg:text-5xl text-[#0A192F] leading-tight">
            One skilled team.{" "}
            <span className="text-[#F97316]">Twenty specialties.</span>
          </h2>
          <p className="mt-5 text-base md:text-lg text-slate-600 leading-relaxed">
            From a stubborn drywall crack to a full room refresh — if it needs fixing,
            installing, mounting, or painting, we do it right.
          </p>
        </div>

        <div className="mt-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-5">
          {SERVICES.map((svc, idx) => {
            const Icon = svc.icon;
            return (
              <motion.a
                key={svc.title}
                href="#contact"
                data-testid={`service-card-${idx}`}
                initial={{ opacity: 0, y: 24 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-40px" }}
                transition={{ duration: 0.4, delay: (idx % 8) * 0.05 }}
                className="group relative bg-white border border-slate-200 rounded-2xl p-6 hover:border-[#F97316]/40 hover:shadow-[0_12px_32px_-12px_rgba(10,25,47,0.15)] transition-all hover:-translate-y-1"
              >
                <div className="flex items-start justify-between">
                  <div className="h-12 w-12 rounded-xl bg-[#F97316]/10 grid place-items-center group-hover:bg-[#F97316] transition-colors">
                    <Icon
                      strokeWidth={1.6}
                      className="h-6 w-6 text-[#F97316] group-hover:text-white transition-colors"
                    />
                  </div>
                  <ArrowUpRight className="h-4 w-4 text-slate-300 group-hover:text-[#F97316] transition-colors" />
                </div>
                <h3 className="mt-6 font-display font-semibold text-lg text-[#0A192F] leading-tight">
                  {svc.title}
                </h3>
                <p className="mt-2 text-sm text-slate-500 leading-relaxed">{svc.desc}</p>
              </motion.a>
            );
          })}

          {/* Bridge card to new Mobile Auto Detailing service */}
          <motion.a
            href="#detailing"
            data-testid="services-detailing-bridge"
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-40px" }}
            transition={{ duration: 0.45, delay: 0.1 }}
            className="group relative overflow-hidden rounded-2xl p-6 bg-gradient-to-br from-[#0A192F] to-[#102A4C] text-white border border-[#F97316]/30 hover:border-[#F97316] hover:shadow-[0_18px_40px_-12px_rgba(249,115,22,0.45)] transition-all hover:-translate-y-1"
          >
            <span className="absolute -top-10 -right-10 h-32 w-32 rounded-full bg-[#F97316]/20 blur-2xl group-hover:bg-[#F97316]/35 transition-colors" />
            <div className="relative flex items-start justify-between">
              <div className="h-12 w-12 rounded-xl bg-[#F97316] grid place-items-center shadow-lg">
                <Car strokeWidth={1.7} className="h-6 w-6 text-white" />
              </div>
              <span className="rounded-full bg-[#F97316]/15 border border-[#F97316]/40 px-2.5 py-1 text-[10px] font-bold uppercase tracking-widest text-[#F97316]">
                New
              </span>
            </div>
            <h3 className="relative mt-6 font-display font-semibold text-lg leading-tight">
              Mobile Auto Detailing
            </h3>
            <p className="relative mt-2 text-sm text-white/65 leading-relaxed">
              We come to you — interior, exterior & full-detail packages.
            </p>
            <span className="relative mt-5 inline-flex items-center gap-1.5 text-sm font-semibold text-[#F97316]">
              Explore detailing
              <ArrowUpRight className="h-4 w-4 group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform" />
            </span>
          </motion.a>
        </div>

        <div className="mt-14 text-center">
          <a href="#contact" data-testid="services-cta" className="rs-btn-primary">
            Not sure? Ask us anything
          </a>
        </div>
      </div>
    </section>
  );
}
